import { render, staticRenderFns } from "./View12.vue?vue&type=template&id=7b66f63a"
import script from "./View12.vue?vue&type=script&lang=js"
export * from "./View12.vue?vue&type=script&lang=js"
import style0 from "./View12.vue?vue&type=style&index=0&id=7b66f63a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports